// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_eh-a";
export var fulfillmentFormRail = "_eh-9";
export var headerTitleRow = "_eh-c";
export var orderDetailsWrapper = "_eh-7";
export var orderLinkTrigger = "_eh-2";
export var paymentInformationGrid = "_eh-h";
export var paymentSummaryColumn = "_eh-i";
export var shipmentContainer = "_eh-b";
export var shipmentDetailsMainPane = "_eh-8";
export var shipmentNavigationCard = "_eh-5";
export var shipmentNavigationRail = "_eh-3";
export var shipmentNavigationRailHeader = "_eh-4";
export var shipmentSummaryFact = "_eh-e";
export var shipmentSummaryGrid = "_eh-d";
export var shipmentSummaryMetadataRow = "_eh-f";
export var shipmentSummaryTags = "_eh-g";
export var shipmentWorkspace = "_eh-0";
export var shipmentWorkspaceContent = "_eh-6";
export var shipmentWorkspaceHeader = "_eh-1";